import React from "react";
import Logo from "./Logo";
import i18n from "../i18n";
import { appConstants } from "../../utils/constants";

import "../../assets/css/header.css";
import { useDashboardContext } from "../../context/customhook/dashboardHook";

function NpsHeader() {
  const { dashboardStates, setDashboardStates } = useDashboardContext();

  const languageOnClick = () => {
    let CurrentLanguage = localStorage.getItem(appConstants.language);

    i18n.changeLanguage(
      CurrentLanguage?.includes(appConstants.en)
        ? appConstants.ar
        : appConstants.en
    );

    localStorage.setItem(
      appConstants.language,
      CurrentLanguage?.includes(appConstants.en)
        ? appConstants.ar
        : appConstants.en
    );

    setDashboardStates((previousState) => {
      return {
        ...previousState,
        pageDirection: CurrentLanguage?.includes(appConstants.en)
          ? appConstants.rtl
          : appConstants.ltr,
        parentQuestionId: null,
        childQuestionId: null,
        parentQuestiondata: null,
        childQuestiondata: null,
      };
    });
  };

  return (
    <div className="header-container">
      <Logo />
      {!dashboardStates.isSourceWeb && (
        <div className="switch">
          <button className="unstyled-button" onClick={() => languageOnClick()}>
            {localStorage
              .getItem(appConstants.language)
              ?.includes(appConstants.ar)
              ? appConstants.english
              : appConstants.arabic}
          </button>
        </div>
      )}
    </div>
  );
}

export default NpsHeader;
